export default __webpack_public_path__ + "static/media/mob_preland_9.8a6ca2c0.jpg";